import React from 'react';
import { TEMPLATE_MERGE_FIELDS } from './stripo/stripoMergeFields';
import styles from './SendMessageStep.module.css';

export const MergeFields: React.FC = () => (
  <aside className={styles.mergeFields}>
    <h3>Personalization</h3>
    <p>Add dynamic fields to personalize your email or SMS:</p>
    {TEMPLATE_MERGE_FIELDS.map(group => (
      <section key={group.category}>
        <h4>{group.category}</h4>
        <div>
          {group.entries.map(field => (
            <code key={field.value}>{field.value}</code>
          ))}
        </div>
      </section>
    ))}
  </aside>
);
